module.exports = __webpack_public_path__ + "img/cyan.ba7b26e0.jpg";